import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { DropzoneComponent } from 'react-dropzone-component'
import { DesignContext } from 'contexts/DesignContext'
import CustomButton from './Button'
import objectPath from 'object-path'
import Label from './Label'
import Dropzone from './dropzone/Dropzone'
import httpClient from 'utility/httpClient.util'
import Swal from 'sweetalert2'

const CustomFileUpload = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, elementAction } = designContext
  let { uischema, config } = props

  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicData = {},
    onUpdateFormData = () => {},
    isArray,
    arrayName,
  } = config

  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name
  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  const isMulti = objectPath.get(uischema, 'isMulti') ? true : false
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = objectPath.get(elementAction, ['isEnable', uischema.key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let formData = objectPath.get(jsonForm, 'formData')
  let files = objectPath.get(formData, uischema.key) || []
  const [fileList, setFileList] = useState([])
  let extension = (uischema.extension || []).map((item) =>
    item.replace('.', '')
  )
  const allowExt = extension ?? [
    'jpeg',
    'jpg',
    'png',
    'pdf',
    'doc',
    'docx',
    'txt',
  ]

  const mediaGroupCode = ''
  const mediaGroupId = ''
  const titleName = ''
  const capture = ''

  const onSave = async () => {
    if (capture) {
      const formData = new FormData()
      formData.append('file', files?.image)
    } else {
      const formData = new FormData()
      for (const file of files) {
        formData.append('file', file)
      }

      const headers = {
        headers: { 'content-type': 'multipart/form-data' },
      }

      try {
        const imageReq = await httpClient
          .post(
            `/media/attachment/uploads/${mediaGroupCode}?titleName=${titleName}`,
            formData,
            headers
          )
          .then(({ data }) => data.data)
        if (imageReq) {
        } else {
          Swal.fire('Error!', 'บันทึกไม่สำเร็จ', 'error')
        }
      } catch (e) {
        console.error(e)
        Swal.fire(
          'Error! ' + e?.status,
          'อับโหลดไม่สำเร็จ ' + e?.message,
          'error'
        )
      }
    }
  }
  const [pastedFiles, setPastedFiles] = useState(null)
  const [render, setRender] = useState(null)

  useEffect(() => {
    const handlePaste = (event) => {
      const items = event.clipboardData.items

      new Promise((resolve) => {
        let files = []
        for (let i = 0; i < items.length; i++) {
          let file = items[i].getAsFile()
          if (file) {
            let preview = URL.createObjectURL(file)
            Object.assign(file, { preview })
            files.push(file)
          }
        }
        resolve(files)
      }).then((files) => {
        if (isMulti) {
          setPastedFiles(files)
        } else {
          let singleFile = files[0]
          if (singleFile) {
            setPastedFiles([singleFile])
          } else {
            setPastedFiles([])
          }
        }
        setRender(true)
      })
    }
    window.addEventListener('paste', handlePaste)
    return () => {
      window.removeEventListener('paste', handlePaste)
    }
  }, [])

  useEffect(() => {
    if (render) {
      let newFileList = []
      if (isMulti) {
        newFileList = fileList.concat(pastedFiles)
      } else {
        newFileList = pastedFiles
      }
      setFileList(newFileList)
      setRender(false)
    }
  }, [render])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 m-0">
        <Label {...props} uischema={uischema} />
        <Col sm={uischema.elementWidth} className="mt-2">
          <Dropzone
            id={fieldKey}
            isReadOnly={isReadOnly}
            uischema={uischema}
            allowExt={allowExt}
            onSave={onSave}
            stateParent={{
              files: [fileList, setFileList],
            }}
            config={config}
            isFileUpload={true}
          />
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomFileUpload
